import { t } from "i18next"

const semLimiteDefinido = limite => limite === null || limite === undefined || limite === ""

export const isLimiteLicencaExcedido = (limite, ativos) =>
  !semLimiteDefinido(limite) && (ativos || 0) > limite

export const describeLimiteLicenca = limite => semLimiteDefinido(limite)
  ? { label: t("fastfoodmobile.config.licenca.enum.sem-limite"), color: "secondary" }
  : { label: `${ limite }`, color: "info" }

export const describeSaldoLicenca = (limite, saldo) => {
  if (semLimiteDefinido(limite)) {
    return { label: t("fastfoodmobile.config.licenca.enum.sem-limite"), color: "secondary" }
  }
  if (saldo < 0) {
    return { label: t("fastfoodmobile.config.licenca.enum.limite-excedido", { quantidade: Math.abs(saldo) }), color: "danger" }
  }
  if (saldo === 0) {
    return { label: t("fastfoodmobile.config.licenca.enum.limite-atingido"), color: "warning" }
  }
  return { label: t("fastfoodmobile.config.licenca.enum.disponiveis", { quantidade: saldo }), color: "success" }
}
